/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../store/actions";
import { i18n } from '../../../../translate/i18n';
import {
	FormControl, Button, IconButton, FormControlLabel, Switch
} from '@mui/material';
import { FilterList, ArrowUpward, ArrowDownward } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';

import { DivFormTitle } from './styles';
import Autocomplete from '../../../../UI/Autocomplete/Autocomplete';

const EquipmentFilterModal = (props) => {
	const dispatch = useDispatch();

	const [page] = useState(1);
	const [limit] = useState(30);
	const [orderBy] = useState("name");
	const [order] = useState("asc");

	const [searchTextEquipment, setSearchTextEquipment] = useState('');
	const [equipmentsFormated, setEquipmentsFormated] = useState([]);
	const [selectedEquipments, setSelectedEquipments] = useState([]);

	const [searchTextGroup, setSearchTextGroup] = useState('');
	const [groupsFormated, setGroupsFormated] = useState([]);
	const [selectedGroups, setSelectedGroups] = useState([]);

  	const [searchTextArea, setSearchTextArea] = useState('');
	const [areasFormated, setAreasFormated] = useState([]);
	const [selectedAreas, setSelectedAreas] = useState([]);

	const [searchTextCompanies, setSearchTextCompanies] = useState('');
	const [companiesFormated, setCompaniesFormated] = useState([]);
	const [selectedCompanies, setSelectedCompanies] = useState([]);

	const initialStatus = {
		valid: false,
		invalid: {
			inDelay: false,
			notDone: false,
			hasNoServices: false,
			hasActionsOpenedOrOverdue: false,
			mixed: false
		},
		maintenance: false,
		inactive: false
	};

	const [status, setStatus] = useState(initialStatus);
	const [statusInvalidDropdown, setStatusInvalidDropdown] = useState(false);

	const fetchEquipments = useCallback(
		() => dispatch(actions.equipmentsFetchEquipmentModels(page, limit, searchTextEquipment, order, orderBy)),
		[page, limit, searchTextEquipment, order, orderBy]
	);

	const fetchGroups = useCallback(
		() => dispatch(actions.equipmentsFetchGroups(page, limit, searchTextGroup, order, orderBy)),
		[page, limit, searchTextGroup, order, orderBy]
	);

  const fetchAreas = useCallback(
		() => dispatch(actions.equipmentsFetchAreas(page, limit, searchTextArea, order, orderBy)),
		[page, limit, searchTextArea, order, orderBy]
	);

	const fetchCompanies = useCallback(
		() => dispatch(actions.equipmentsFetchCompanies(page, limit, searchTextCompanies, order, orderBy)),
		[page, limit, searchTextCompanies, order, orderBy]
	);

	const role = useSelector(state => state.auth.selectedAccess.role);
	const equipments = useSelector(state => state.equipments.equipmentModels);
	const groups = useSelector(state => state.equipments.groups);
	const areas = useSelector(state => state.equipments.areas);
	const companies = useSelector(state => state.equipments.companies);
	const filteredEquipments = useSelector(state => state.equipments.filtersByPlace.filteredModels);
	const filteredGroups = useSelector(state => state.equipments.filtersByPlace.filteredGroups);
	const filteredAreas = useSelector(state => state.equipments.filtersByPlace.filteredAreas);
	const filteredCompanies = useSelector(state => state.equipments.filtersByPlace.filteredCompanies);
	const filteredStatus = useSelector(state => state.equipments.filtersByPlace.filteredStatus);

	const loadingEquipments = useSelector(state => state.equipments.equipmentModelsLoading);
	const loadingGroups = useSelector(state => state.equipments.groupsLoading);
	const loadingAreas = useSelector(state => state.equipments.areasLoading);
	const loadingCompanies = useSelector(state => state.equipments.companiesLoading);


	useEffect(() => {
		handleInputChangeEquipments(filteredEquipments);
		handleInputChangeGroups(filteredGroups);
		handleInputChangeAreas(filteredAreas);
		handleInputChangeCompanies(filteredCompanies);
		setStatus(filteredStatus)
	}, []);

	useEffect(() => {
		fetchEquipments(limit, searchTextEquipment, order, orderBy);
	}, [searchTextEquipment]);

	useEffect(() => {
		fetchGroups(limit, searchTextGroup, order, orderBy);
	}, [searchTextGroup]);

  useEffect(() => {
		fetchAreas(limit, searchTextArea, order, orderBy);
	}, [searchTextArea]);

	useEffect(() => {
		if (role !== 'contractor') {
      fetchCompanies(limit, searchTextCompanies, order, orderBy);
    }
	}, [searchTextCompanies]);

	useEffect(() => {
		const dataFromRedux = equipments
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setEquipmentsFormated(returnArray)
	}, [equipments])

	useEffect(() => {
		const dataFromRedux = groups
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setGroupsFormated(returnArray)
	}, [groups])

  useEffect(() => {
		const dataFromRedux = areas
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setAreasFormated(returnArray)
	}, [areas])

	useEffect(() => {
		const dataFromRedux = companies
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setCompaniesFormated(returnArray)
	}, [companies])

	const handleInputChangeSelectorEquipments = (text) => {
		setSearchTextEquipment(text);
	}

	const handleInputChangeSelectorGroups = (text) => {
		setSearchTextGroup(text);
	}

	const handleInputChangeGroups = (selected) => {
		setSelectedGroups(selected);
	}

  const handleInputChangeSelectorAreas = (text) => {
		setSearchTextArea(text);
	}

	const handleInputChangeSelectorCompanies = (text) => {
		setSearchTextCompanies(text);
	}

  const handleInputChangeAreas = (selected) => {
		setSelectedAreas(selected);
	}

	const handleInputChangeEquipments = selected => {
		setSelectedEquipments(selected);
	}

	const handleInputChangeCompanies = selected => {
		setSelectedCompanies(selected);
	}

	const handleClickFilter = () => {
		dispatch(actions.filterEquipmentByPlaceModels(selectedEquipments));
		dispatch(actions.filterEquipmentByPlaceGroups(selectedGroups));
		dispatch(actions.filterEquipmentByPlaceAreas(selectedAreas));
		dispatch(actions.filterEquipmentByPlaceCompanies(selectedCompanies));
		dispatch(actions.filterEquipmentByPlaceStatus({
			...status,
			invalid: {
				...status.invalid,
				mixed: false
			}
		}));
		props.closeModal();
	}

	const handleClickClearFilters = () => {
		setSelectedEquipments([])
		setSelectedGroups([])
		setSelectedAreas([])
		setSelectedCompanies([])
		setStatus(initialStatus)
	}

	const handleChangeStatus = (key, value) => {
		if (key === 'invalid') {
			setStatus({
				...status,
				invalid: {
					inDelay: value,
					notDone: value,
					hasNoServices: value,
					hasActionsOpenedOrOverdue: value,
				}
			});
		} else if (key.includes('invalid.')) {
			const invalidKey = key.split('.')[1];
			setStatus({ ...status, invalid: { ...status.invalid, [invalidKey]: value } });
		} else {
			setStatus({ ...status, [key]: value });
		}
	};

	return (
        <div style={styles.container}>
			<DivFormTitle style={styles.headerContainer}>
				<div style={{ display: 'flex', alignItems: 'center', fontSize: '1.25rem' }}>
					<FilterList style={{ marginRight: '1rem' }} />
					{i18n.t('filterListModalFilterEquip.text')}
				</div>
				<IconButton onClick={props.closeModal} color='inherit' size="large">
					<CloseIcon />
				</IconButton>
			</DivFormTitle>
			<div style={styles.bodyContainer}>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingEquipments}
						label={i18n.t('autocompleteModalFilterEquip.equipmentModel')}
						data={equipmentsFormated}
						onSelectValue={handleInputChangeEquipments}
						valueSelected={selectedEquipments}
						newSearchText={handleInputChangeSelectorEquipments}
						id="equipmentModel"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingGroups}
						label={i18n.t('autocompleteModalFilterEquip.groups')}
						data={groupsFormated}
						onSelectValue={handleInputChangeGroups}
						valueSelected={selectedGroups}
						newSearchText={handleInputChangeSelectorGroups}
						id="equipmentGroup"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingAreas}
						label={i18n.t('autocompleteModalFilterEquip.area')}
						data={areasFormated}
						onSelectValue={handleInputChangeAreas}
						valueSelected={selectedAreas}
						newSearchText={handleInputChangeSelectorAreas}
						id="area"
						isMulti
					/>
				</FormControl>
        <FormControl variant="standard" fullWidth margin='normal'>
          <Autocomplete
            loading={loadingCompanies}
            label={i18n.t('autocompleteModalFilterEquip.company')}
            data={companiesFormated}
            onSelectValue={handleInputChangeCompanies}
            valueSelected={selectedCompanies}
            newSearchText={handleInputChangeSelectorCompanies}
            id="company"
            isMulti
          />
        </FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					{i18n.t('autocompleteModalFilterEquip.status')}
					<FormControlLabel
						control={<Switch checked={status.valid} onChange={e => handleChangeStatus('valid', e.target.checked)} />}
						label={i18n.t('statusOptions.valid')}
					/>
					<FormControlLabel
						control={<Switch checked={status.validWithOpenedActions} onChange={e => handleChangeStatus('validWithOpenedActions', e.target.checked)} />}
						label={i18n.t('statusOptions.validWithOpenedActions')}
					/>
					<div style={{display: 'flex', alignItems: 'center'}}>
						<FormControlLabel
							control={
								<Switch
									checked={
										status.invalid.inDelay ||
										status.invalid.notDone ||
										status.invalid.hasNoServices ||
										status.invalid.hasActionsOpenedOrOverdue
									}
									onChange={e => handleChangeStatus('invalid', e.target.checked)}
								/>}
							label={i18n.t('statusOptions.invalid')}
						/>
						{statusInvalidDropdown
							? <IconButton onClick={() => setStatusInvalidDropdown(false)} size="large"><ArrowUpward/></IconButton>
							: <IconButton onClick={() => setStatusInvalidDropdown(true)} size="large"><ArrowDownward/></IconButton>}
					</div>
					{statusInvalidDropdown &&
						<div style={{marginLeft: 20, display: 'flex', flexDirection: 'column'}}>
							<FormControlLabel
								control={<Switch checked={status.invalid.inDelay} onChange={e => handleChangeStatus('invalid.inDelay', e.target.checked)} />}
								label={i18n.t('statusOptions.inDelay')}
							/>
							<FormControlLabel
								control={<Switch checked={status.invalid.notDone} onChange={e => handleChangeStatus('invalid.notDone', e.target.checked)} />}
								label={i18n.t('statusOptions.notDone')}
							/>
							<FormControlLabel
								control={<Switch checked={status.invalid.hasActionsOpenedOrOverdue} onChange={e => handleChangeStatus('invalid.hasActionsOpenedOrOverdue', e.target.checked)} />}
								label={i18n.t('statusOptions.hasActionsOpenedOrOverdue')}
							/>
							<FormControlLabel
								control={<Switch checked={status.invalid.hasNoServices} onChange={e => handleChangeStatus('invalid.hasNoServices', e.target.checked)} />}
								label={i18n.t('statusOptions.hasNoServices')}
							/>
						</div>
					}
					<FormControlLabel
						control={<Switch checked={status.maintenance} onChange={e => handleChangeStatus('maintenance', e.target.checked)} />}
						label={i18n.t('statusOptions.maintenance')}
					/>
					<FormControlLabel
						control={<Switch checked={status.inactive} onChange={e => handleChangeStatus('inactive', e.target.checked)} />}
						label={i18n.t('statusOptions.inactive')}
					/>
				</FormControl>
			</div>
			<div style={styles.footerContainer}>
				<div
					onClick={props.closeModal}
					style={styles.buttonCancel}
				>
					{i18n.t('divModalFilterEquip.cancel')}
				</div>
				<Button
					variant='contained'
					color='primary'
					onClick={handleClickFilter}
					style={styles.button}
				>
					{i18n.t('divModalFilterEquip.ok')}
				</Button>
			</div>
		</div>
    );
}

const styles = {
	container: {
		width: '40rem',
		height: '100%'
	},
	headerContainer: {
		height: '5rem',
		padding: '0 1rem 0 2rem',
		backgroundColor: 'green',
		color: '#fff',
	},
	bodyContainer: {
		height: 'calc(100% - 10rem)',
		padding: '1rem 2rem',
		overflowY: 'auto',
		borderTop: '1px solid #ccc',
		borderBottom: '1px solid #ccc',
	},
	chip: {
		display: 'flex',
		alignItems: 'center',
		backgroundColor: '#C5D1E3',
		margin: '0.5rem 0',
		borderRadius: 10,
		padding: '0.3rem 1rem',
		justifyContent: 'space-between'
	},
	footerContainer: {
		height: '5rem',
		padding: '0 2rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	button: {
		flex: 1,
		backgroundColor: 'green',
		borderRadius: '2rem',
		padding: '0.5rem 1.5rem',
		// width: '100%',
	},
	buttonCancel: {
		flex: 1,
		cursor: 'pointer',
		color: 'grey',
		alignItems: 'center',
		textAlign: 'center',
	},
	clearFilter: {
		fontSize: '1rem',
		marginLeft: '2rem',
		color: '#fff',
		cursor: 'pointer',
		textDecoration: 'underline'
	}
}


export default EquipmentFilterModal;

